/** A recorded try (the shape useStep's updateProgress takes). */
export interface MistakeTry {
  result: boolean;
  answer?: string;
  duration: number;
  final?: boolean;
  isHelp?: boolean;
  isTimeout?: boolean;
}

/**
 * The try a wrong answer (or a HELP request) records under the drill's
 * handling_of_mistakes: 'Repeat the question' keeps the question open
 * (final: false); 'Allow Correction of Mistakes' records nothing (null).
 */
export function mistakeTry(
  result: boolean,
  answer: string,
  duration: number,
  isHelp: boolean | undefined,
  handlingOfMistakes: string | undefined,
): MistakeTry | null {
  const progressData: MistakeTry = { result, duration };

  if (isHelp) {
    progressData.isHelp = true;
  } else {
    progressData.answer = answer;
  }

  switch (handlingOfMistakes) {
    case 'Allow Correction of Mistakes':
      return null;
    case 'Repeat the question':
      progressData.final = false;
      return progressData;
    case 'Go to Next Question':
    default:
      return progressData;
  }
}
